import axios, {
  AxiosError,
  AxiosResponse,
  InternalAxiosRequestConfig,
} from "axios";
// import { setupInterceptors } from './authInterceptor';
import { getToken, refreshToken } from "./authService";

interface AxiosRequestConfigWithRetry extends InternalAxiosRequestConfig {
  _retry?: boolean;
}

const API_BASE_URL =
  process.env.REACT_APP_API_URL || "http://localhost:8080/api";

const axiosInstance = axios.create({
  baseURL: API_BASE_URL,
  // withCredentials: true,
  headers: {
    "Content-Type": "application/json",
  },
});

const authInterceptor = async (
  config: InternalAxiosRequestConfig
): Promise<InternalAxiosRequestConfig> => {
  const token = getToken();

  if (token && config.headers) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  return config;
};

const refreshTokenInterceptor = async (
  error: AxiosError
): Promise<AxiosResponse | void> => {
  const originalRequest = error.config as AxiosRequestConfigWithRetry;

  // Token scaduto: prova a rinnovarlo e ripete la richiesta originale
  if (error.response?.status === 401 && !originalRequest._retry) {
    originalRequest._retry = true;

    try {
      await refreshToken();
      return axiosInstance(originalRequest);
    } catch (refreshError) {
      console.error("Errore durante il refresh del token:", refreshError);
      throw refreshError;
    }
  }

  // Estrai il messaggio leggibile dal body RFC7807 del backend, se presente
  const responseData = error.response?.data as Record<string, unknown> | undefined;
  if (responseData?.detail && typeof responseData.detail === "string") {
    error.message = responseData.detail;
  } else if (responseData?.title && typeof responseData.title === "string") {
    error.message = responseData.title;
  }

  throw error;
};

axiosInstance.interceptors.request.use(authInterceptor);
axiosInstance.interceptors.response.use(
  (response) => response,
  refreshTokenInterceptor
);
// setupInterceptors();

export default axiosInstance;
